import React from 'react';
import CmtCard from '../../../@coremat/CmtCard';
import CmtCardHeader from '../../../@coremat/CmtCard/CmtCardHeader';
import CmtCardContent from '../../../@coremat/CmtCard/CmtCardContent';
import { makeStyles } from '@material-ui/core/styles';
import { formatNumber } from './utils/formatDashboard';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    height: '100%',
  },
  statRow: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0),
    borderBottom: `1px solid ${theme.palette.divider}`,
    '&:last-child': { borderBottom: 'none' },
  },
}));

const UserStatsSection = ({ users, loading }) => {
  const classes = useStyles();

  const rows = users
    ? [
        { label: 'Total Accounts', value: formatNumber(users.totalAccounts) },
        { label: 'Personal', value: formatNumber(users.personalAccounts) },
        { label: 'Agent', value: formatNumber(users.agentAccounts) },
        { label: 'System', value: formatNumber(users.systemAccounts) },
      ]
    : [];

  return (
    <CmtCard className={classes.cardRoot}>
      <CmtCardHeader title="User Statistics" />
      <CmtCardContent>
        {loading ? (
          <Skeleton variant="text" height={40} />
        ) : (
          rows.map(({ label, value }) => (
            <div key={label} className={classes.statRow}>
              <Typography variant="body2" color="textSecondary">
                {label}
              </Typography>
              <Typography variant="body2" fontWeight={600}>
                {value}
              </Typography>
            </div>
          ))
        )}
      </CmtCardContent>
    </CmtCard>
  );
};

export default UserStatsSection;
